import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from './contexts/ThemeContext.jsx';
import './styles/globals.css';
import './index.css';
import ScrollToTop from './components/layout/ScrollToTop';

import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import BulkSupplyService from './pages/BulkSupplyService';
import CustomPackagingService from './pages/CustomPackagingService';
import QualityTestingService from './pages/QualityTestingService';
import LogisticsSupportService from './pages/LogisticsSupportService';
import Contact from './pages/Contact';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsAndConditions from './pages/TermsAndConditions';
import FAQ from './pages/FAQ';
import Products from './pages/Products';
import FoodWrapPaper from './pages/FoodWrapPaper';
import BakerySolutions from './pages/BakerySolutions';
import PaperPlates from './pages/PaperPlates';
import PaperCupSleeves from './pages/PaperCupSleeves';
import RipplePaperCupSleeves from './pages/RipplePaperCupSleeves';
import PaperBags from './pages/PaperBags';
import PaperCarryBags from './pages/PaperCarryBags';

// New Product Pages - Paper Category
import PECoatedRolls from './pages/PECoatedRolls';
import NotebookCoverJumboRolls from './pages/NotebookCoverJumboRolls';
import SoapStiffenerPaper from './pages/SoapStiffenerPaper';
import Packaging from './pages/Packaging';
import PESilverCoatedEnvelopePaper from './pages/PESilverCoatedEnvelopePaper';

// New Product Pages - Raw Material Category
import SugarSachets from './pages/SugarSachets';
import PouchesRolls from './pages/PouchesRolls';
import CupBottoms from './pages/CupBottoms';
import ContainerSleeves from './pages/ContainerSleeves';
import BoxTraySleeves from './pages/BoxTraySleeves';

function App() {
  return (
    <ThemeProvider>
      <Router>
        <ScrollToTop />
        <div className="App site-root">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/services" element={<Services />} />
            <Route path="/services/bulk-supply" element={<BulkSupplyService />} />
            <Route path="/services/custom-packaging" element={<CustomPackagingService />} />
            <Route path="/services/quality-testing" element={<QualityTestingService />} />
            <Route path="/services/logistics-support" element={<LogisticsSupportService />} />
            <Route path="/products" element={<Products />} />
            
            {/* Existing Product Routes */}
            <Route path="/products/food-wrap-paper" element={<FoodWrapPaper />} />
            <Route path="/products/bakery-solutions" element={<BakerySolutions />} />
            <Route path="/products/paper-plates" element={<PaperPlates />} />
            <Route path="/products/paper-cup-sleeves" element={<PaperCupSleeves />} />
            <Route path="/products/ripple-paper-cup-sleeves" element={<RipplePaperCupSleeves />} />
            <Route path="/products/paper-bags" element={<PaperBags />} />
            <Route path="/products/paper-carry-bags" element={<PaperCarryBags />} />
            
            {/* New Product Routes - Paper Category */}
            <Route path="/products/pe-coated-rolls" element={<PECoatedRolls />} />
            <Route path="/products/notebook-cover-jumbo-rolls" element={<NotebookCoverJumboRolls />} />
            <Route path="/products/soap-stiffener-paper" element={<SoapStiffenerPaper />} />
            <Route path="/products/packaging" element={<Packaging />} />
            <Route path="/products/pe-silver-coated-envelope-paper" element={<PESilverCoatedEnvelopePaper />} />
            
            {/* New Product Routes - Raw Material Category */}
            <Route path="/products/sugar-sachets" element={<SugarSachets />} />
            <Route path="/products/pouches-rolls" element={<PouchesRolls />} />
            <Route path="/products/cup-bottoms" element={<CupBottoms />} />
            <Route path="/products/container-sleeves" element={<ContainerSleeves />} />
            <Route path="/products/box-tray-sleeves" element={<BoxTraySleeves />} />
            
            <Route path="/contact" element={<Contact />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="/terms" element={<TermsAndConditions />} />
          </Routes>
        </div>
      </Router>
    </ThemeProvider>
  );
}

export default App;
